var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('data-table',{attrs:{"items":_vm.tableConfig.items.value,"fields":_vm.tableConfig.fields,"loading":_vm.loading,"data-cy":"features-table","search-data-cy":"feature-search"},scopedSlots:_vm._u([{key:"value-enabled",fn:function(ref){
var item = ref.item;
var value = ref.value;
var field = ref.field;
return [_c('v-switch',{staticClass:"ma-0",attrs:{"hide-details":"","color":"primary","inset":"","disabled":true},on:{"change":function (value) { return _vm.updateItem(item.id, value); }},model:{value:(item.enabled),callback:function ($$v) {_vm.$set(item, "enabled", $$v)},expression:"item.enabled"}})]}},{key:"value-createdAt",fn:function(ref){
var item = ref.item;
var value = ref.value;
var field = ref.field;
return [_vm._v(" "+_vm._s(_vm._f("moment")(value,"from"))+" ")]}},{key:"value-updatedAt",fn:function(ref){
var item = ref.item;
var value = ref.value;
var field = ref.field;
return [_vm._v(" "+_vm._s(_vm._f("moment")(value,"from"))+" ")]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }